import { Image, Modal } from "react-bootstrap";
import "../../assets/scss/components/templates/feedbackModal.scss";
import closeBtn from "../../assets/images/resume/closeModal.svg";
import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import middleware from "../../middleware/middleware";
import {
  showToast,
  getBaseApiURL,
  console_log,
} from "../../utils/commonHelper";
import loading from "../../assets/images/loading.svg";
import successIcon from "../../assets/images/resume/success_circle.svg"; // Add a success icon
import likeIcon from "../../assets/images/resume/likeIcon.svg";
import dislikeIcon from "../../assets/images/resume/dislikeIcon.svg";
import { resumeFeedbackToApi } from "../../pages/resumeDetails/helper";

const FeedbackModal = (props) => {
  // const metadata = useSelector((state) => state.resumeDetails.metadata);
  const [feedback, setFeedback] = useState("");
  const [success, setSuccess] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [feedBackPopupTitle, setFeedbackPopupTitle] = useState("Feedback");
  const submitFeedbackFunction = async () => {
    try {
      setIsDisabled(true);
      const feedbackObject = {
        feedback_object: props.feedbackObject,
        feedback_score: props.feedbackValue,
        feedback_description: feedback,
      };
      const response = await resumeFeedbackToApi(
        props.resumeId,
        feedbackObject
      );
      console_log("response....", response);
      setFeedbackPopupTitle("");
      setSuccess(true);
      setIsDisabled(false);
    } catch (err) {
      setIsDisabled(false);
    }
  };
  const handleInputChange = (e) => {
    setFeedback(e.target.value); // Updates the full value in state
  };

  useEffect(() => {
    if (props.showmodal) {
      setSuccess(false); // Reset success state when modal is opened
      setFeedback("");
      setFeedbackPopupTitle("Feedback");
    }
  }, [props.showmodal]);

  const renderBody = () => {
    if (success) {
      return (
        <div className="success-container text-center">
          <Image src={successIcon} alt="Success" />
          <h5 className="heading-5 mt-3">Feedback Submitted Successfully!</h5>
        </div>
      );
    }
    return (
      <>
        <p className="mb-2">
          You have selected{" "}
          {props.feedbackValue ? (
            <img src={likeIcon} alt="" className="like-button" />
          ) : (
            <img src={dislikeIcon} alt="" />
          )}
        </p>
        <div className="textarea">
          <textarea
            placeholder="Enter your Feedback Here (optional)"
            rows="5"
            className="answer-box"
            value={feedback}
            onPaste={(e) => console_log(e.nativeEvent)}
            onChange={handleInputChange}
          />
        </div>

        <button
          className="btn btn-primary"
          onClick={() => submitFeedbackFunction()}
          disabled={isDisabled}
        >
          <span> Submit Feedback</span>
          <img className="loading-icon" src={loading} alt="" />
        </button>
      </>
    );
  };
  return (
    <Modal
      show={props.showmodal}
      onHide={props.closemodal}
      className="feedback-modal"
    >
      <div className="d-flex align-items-center justify-content-between ">
        <div className="text-left">
          <h5 className="heading-5 mb-3">{feedBackPopupTitle}</h5>
        </div>
        <Image
          src={closeBtn}
          onClick={props.closemodal}
          className="close-btn align-self-end"
        />
      </div>
      {renderBody()}
    </Modal>
  );
};

export default FeedbackModal;
